import { render } from "./TheImageViewer.vue?vue&type=template&id=1eaa7709&scoped=true&ts=true"
import script from "./TheImageViewer.vue?vue&type=script&lang=ts"
export * from "./TheImageViewer.vue?vue&type=script&lang=ts"

import "./TheImageViewer.vue?vue&type=style&index=0&id=1eaa7709&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eaa7709"]])

export default __exports__